import $ from 'jquery';
import slick from 'slick-carousel';
import config from '../app-config';

function setTabnav() {
    const tabnav = $('.tabnav');

    tabnav.slick({
        dots: false,
        arrows: false,
        variableWidth: true,
        infinite: false,
        edgeFriction: 0,
        swipeToSlide: true
    });
}

function init() {
    if ($(window).width() < config.breakpoints.medium && $('.tabnav').length > 0) setTabnav();
}

export { init };


// WEBPACK FOOTER //
// ./src/_app/layout/tabnav.js